<template>
  <div>
    <gSwiper :arr="arr2" :maxH="'inherit'"></gSwiper>
    <div class="register">
      <Row :gutter="10" class="top">
        <Col span="16">
        <div class="title">中国国际焙烤展 展商报名</div>
        </Col>
        <Col span="8" class="f-tar">
        <Button shape="circle" style="margin-left:10px"
          @click="$router.push(`/ex-register-en/register-mobile`)">English</Button>
        </Col>
      </Row>
      <registerForm ref="registerForm"></registerForm>
      <registerEntrance ref="registerEntrance"></registerEntrance>

      <div class="f-tac submit-btn">
        <Button type="primary" size="large" @click="handleSubmit" :loading="loading">确认以上信息，并提交展位申请</Button>
      </div>

      <div class="tip-info">
        <p>注：</p>
        <p>1. 展会主办单位有修改、调整展位图的权利。</p>
        <p>2. 此表仅为展位预定时使用，非正式参展合同。正式参展以展位合同为准。</p>
        <p>3.特别提醒：每家展商在签署展位合同的时候，还需同时签署为期1年的B2B线上服务，目前年费优惠价2000元（原价5000元），敬请知悉。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import registerForm from "./components/mobile-register-form.vue";
import registerEntrance from "./components/mobile-register-entrance.vue";
import gSwiper from "@components/gSwiper/gSwiper2.vue";
import axios from "axios";
import { MD5 } from 'crypto-js';
import config from '@assets/config.json';
export default {
  name: 'register',
  components: {
    registerForm,
    registerEntrance, gSwiper
  },
  props: {},
  data() {
    return {
      loading: false,
      // arr2: [{ id: 1, path: "https://obs.bakerychina.com/cloudExhibition/imgs/202410/e8d24f1054da4185ae0d8fa3f46ab100.jpg" }],
      arr2: [{ id: 1, path: "https://obs.bakerychina.com/imgs/202512/23330eea0379477fa122bc339f375825.jpg" }],
    };
  },
  watch: {},
  computed: {
  },
  methods: {
    ...mapActions({
      getApplyCompanyRoastCreate: 'registerdModule/getApplyCompanyRoastCreate', // 新增展会接口
    }),
    // 获取随机6位字符串
    getRandomString(length) {
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      let result = '';
      for (let i = 0; i < length; i++) {
        result += characters.charAt(Math.floor(Math.random() * characters.length));
      }
      return result;
    },
    // 获取时间
    getUTCTimestampInSeconds() {
      const now = new Date(); // 获取当前时间
      const utcTimestampInMilliseconds = now.getTime(); // 获取当前时间的毫秒时间戳
      const utcTimestampInSeconds = Math.floor(utcTimestampInMilliseconds / 1000); // 转换为秒
      return utcTimestampInSeconds;
    },
    // 获取token
    async token(opt) {
      try {
        const params = new URLSearchParams();
        params.append('client_id', 'MYDev-YPVMbMBCaNCxMZlxjdnvEmZLDacXec');
        params.append('client_secret', 'pdLudeaW4OLZiqt8U7hXoqI5W7BxQujBSqXG');
        params.append('grant_type', 'client_credentials');
        params.append('scope', 'open_api');

        const response = await axios.post('https://api-ecrm.reed-sinopharm.com/connect/token', params, {
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          }
        });
        if (response.data.access_token) {
          this.tokens = response.data.access_token;
          this.myOtherCreate(opt)
        }
      } catch (error) {
        console.error('Error:', error);
      }

    },
    async handleSubmit() {
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      }, 5000);



      let res = await this.$refs.registerForm.handleSubmit();
      this.loading = false;
      if (!res.valid) return;
      let res2 = await this.$refs.registerEntrance.validHandle();
      this.loading = false;
      if (!res2.valid) return;

      let lists = [];
      if (res2.ApplyCompanyOrderNewDto) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto
        });
      }
      if (res2.ApplyCompanyOrderNewDto2) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto2
        });
      }
      if (res2.ApplyCompanyOrderNewDto3) {
        lists.push({
          ...res2.ApplyCompanyOrderNewDto3
        });
      }
      let opt = {
        newCompany: { ...res.form, ...res2.common },
        lists: lists,
        reportType: 'cn'
      };
      let exname = '';
      res2.exhibition.forEach((c, index) => {
        exname += c.name;
        if (res2.exhibition.length !== index + 1) {
          exname += ','
        }
      });
      console.log('option', opt);
      // this.token(opt)

      let bool = await this.getApplyCompanyRoastCreate(opt);
      console.log('getApplyCompanyRoastCreate', bool);
      if (bool && bool.successed) {
        let query = 'company=' + encodeURI(res.form.companyName) + '&exname=' + sessionStorage.setItem('exname', exname);
        this.$router.push(`/ex-register/register-result?${query}`);
      } else {
        let errTxt = bool.msg || bool.info || "提交失败，请重新尝试！";
        if (bool.errors && bool.errors[0] && bool.errors[0].description) {
          errTxt = bool.errors[0].description;
        }
        this.$Message.error(errTxt);
      }

    },
    // 提交到慕渊云
    async myOtherCreate(opt) {

      const xAdprvClientId = 'MYDev-YPVMbMBCaNCxMZlxjdnvEmZLDacXec'
      const xAdprvClientSecret = 'j7hua3qeZhF1iriZHu5OlXztCz1xrV7QCfAKHxrYt9w='
      const noncestr = this.getRandomString(6)
      const timer = this.getUTCTimestampInSeconds()

      const sign = `x-adprv-client-id=${xAdprvClientId}\\\\x-adprv-client-secret=${xAdprvClientSecret}\\\\x-adprv-noncestr=${noncestr}\\\\x-adprv-timestamp=${timer}`
      const signMd5 = MD5(sign).toString();
      const address = {
        country: opt.newCompany.country,
        province: opt.newCompany.province,
        city: opt.newCompany.city,
        county: '',
        details: opt.newCompany.address,
        postcode: opt.newCompany.postcode
      }
      const contacts = [{
        "kind": '展会联系人',
        "name": opt.newCompany.linkMan,
        "jobTitle": opt.newCompany.linkTitle,
        "phoneNumber": opt.newCompany.linkMob,
        "email": opt.newCompany.linkEmail,
        "tel": {
          countryCode: '',
          areaCode: opt.newCompany.linkCode || '',
          code: opt.newCompany.linkTelephone || '',
          subcode: ''
        },
        "qq": opt.newCompany.linkQQ,
        "weChat": opt.newCompany.linkWeChat,
      }, {
        "kind": '市场部负责人',
        "name": opt.newCompany.leader,
        "jobTitle": opt.newCompany.leaderTitle,
        "phoneNumber": opt.newCompany.leaderMob,
        "email": opt.newCompany.leaderEmail,
        "tel": {
          countryCode: '',
          areaCode: opt.newCompany.LeaderCode || '',
          code: opt.newCompany.leaderTelephone || '',
          subcode: ''
        },
        "qq": opt.newCompany.leaderQQ,
        "weChat": opt.newCompany.leaderWeChat,
      }]
      const deliveryAddress = {
        country: opt.newCompany.invoiceMalingCountry,
        province: opt.newCompany.invoiceMalingProvince,
        city: opt.newCompany.invoiceMalingCity,
        county: '',
        details: opt.newCompany.invoiceMalingAdress,
        postcode: opt.newCompany.invoiceMalingCode,
      }
      const booths = []
      opt.lists.forEach((value, index) => {
          booths.push({
            "exhibitionId": value.exhibitionId == '88be7d87-1d88-47c2-b444-0ab8af9ae681' ? 'a03cb8e3-f76e-635d-6e4d-3a14d23a7ca9' : 'fe7736bf-25e1-a654-9e9b-3a16183f2138',
            "kind": value.ApplyBoothOrder.boothType == '光地' ? '特装' : '标展',
            "name": value.areaName,
            "num": value.ApplyBoothOrder.boothType == '光地' ? value.showArea : parseFloat((value.showArea / 9).toFixed(2)),
            "hall": value.exHall
          })

      })
      let currentId = opt.lists[0].exhibitionId == '88be7d87-1d88-47c2-b444-0ab8af9ae681' ? 'a03cb8e3-f76e-635d-6e4d-3a14d23a7ca9' : 'fe7736bf-25e1-a654-9e9b-3a16183f2138'
      const response = await axios
        .post(
          `${config.apiMy.reqApi}/api/v1/intention/CMEFOtherCreate`,
          {
            "name": opt.newCompany.companyName,
            "nameEn": opt.newCompany.companyNameEn,
            "shortName": opt.newCompany.companyNameShort,
            "shortNameEn": '',
            "unicode": opt.newCompany.unifiedCode,
            "address": address,
            "addressEn": "",

            "website": opt.newCompany.website,
            "attachmentBusinessLicenseImgUrl": opt.newCompany.imgBusinessLicense ? JSON.parse(opt.newCompany.imgBusinessLicense).url : '',
            "fax": "",
            "invoiceDto": {
              "lookUp": opt.newCompany.invoiceTitle,
              "taxNumber": opt.newCompany.invoiceCode,
              "address": opt.newCompany.invoiceAddress,
              "bank": opt.newCompany.invoiceBank,
              "bankAccount": opt.newCompany.invoiceBankAccount,
              "tel": opt.newCompany.invoiceTelephone,
            },
            "invoiceRemark": '',
            "attachmentLogoUrl": '',
            "contacts": contacts,
            "booths": booths,
            "specialFileds": {
              "parentName": opt.newCompany.isBelongChild ? opt.newCompany.parentCompanyName : '',
              "invoiceType": opt.newCompany.invoiceType,
              "invoiceAddress": JSON.stringify(deliveryAddress),
              "invoiceReveiver": opt.newCompany.invoiceRecivePerson,
              "invoiceReveiverTel": opt.newCompany.invoiceReciveTel,
              "joinProductType": opt.newCompany.productName,
              "advertPlan": opt.newCompany.planAd,
            },
            "projectId": "46659337-5542-bb40-74a9-3a14d23a7c6e",
            "exhibitionId": currentId
          },
          {
            headers: {
              'x-exhibition-id': currentId,
              'x-project-id': '46659337-5542-bb40-74a9-3a14d23a7c6e',
              'content-type': 'application/json',
              'x-adprv-noncestr': noncestr,
              'x-adprv-timestamp': timer,
              'x-adprv-sign': signMd5,
              'Authorization': 'Bearer ' + this.tokens
            }
          }
        )
    },
    IsPC() {
      var userAgentInfo = navigator.userAgent;
      var Agents = ["Android", "iPhone",
        "SymbianOS", "Windows Phone",
        "iPad", "iPod"];
      var flag = true;
      for (var v = 0; v < Agents.length; v++) {
        if (userAgentInfo.indexOf(Agents[v]) > 0) {
          flag = false;
          break;
        }
      }
      return flag;
    }
  },
  created() {

    if (this.IsPC()) {
      this.$router.push(`/ex-register/register`);
    }
    document.title = '国际焙烤展'
  },
  mounted() { }
}

</script>

<style lang="scss" scoped>
.register {
  max-width: 1200px;
  margin: 0 auto;
  overflow: hidden;

  .top {
    padding: 15px;
  }

  .title {
    font-size: 15px;
    color: #b10042;
    font-weight: bold;
    line-height: 32px;
  }
}

.submit-btn {
  margin-top: 50px;
  text-align: center;

  button {
    padding: 0 46px;
    background-color: #b10042;
    font-size: 16px;
    border-color: #b10042;
    margin-bottom: 30px;
    height: 40px;
    border-radius: 20px;
    font-size: 15px;
    color: #fff;
  }
}

.tip-info {
  margin: 0 auto 48px;
  padding: 15px;
  white-space: nowrap;

  p {
    font-size: 12px;
    color: #666;
    margin-bottom: 4px;
    white-space: normal;
  }
}
</style>
